// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getFastenersTableApiParameter = (state: ApplicationState) => {
    return state.store.components.fastenersTable.getFastenersApiParameter;
};
